import { Component, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import {
  CalendarModal,
  CalendarModalOptions,
  DayConfig,
  CalendarResult,
} from "ion2-calendar";
import { CalendarComponentOptions } from "ion2-calendar";
import { Http, Headers, RequestOptions, URLSearchParams } from "@angular/http";

import "rxjs/add/operator/map";

@Injectable()
export class VariablesProvider {
  public MODO = "real";
  // Preferencia de empresa: anexo explicativo en el informe normal.
  public PDF_DETALLE_EXPLICATIVO = false;
  public _daysConfig: DayConfig[] = [];
  public DIA;
  public DIASALA;
  public diasOcupados;

  public subuser;
  public volverDespuesVacaciones: any = null;

  public licencianumero="";
  public licenciafecha="";
  public licencianombre="";
  public licenciaactiva="";
  public licenciadiasrestantes="";  
  public licenciaestado="";  

  public primeravez = "si";

  public usuariomapa = "todos";
  public usuariomapaid = "";

  public logged;
  public username;
  public usermail;
  public uservalor;
  public uservalor2;
  public pages: Array<{ title: string; visible: string }>;

  public asignacionesCargadasMes: string | null = null;

  public APPSELECT = "pica";

  public emailactivo; // no modificable
  public emailoriginal;
  public CLIENTES_CONTACTO;
  public CLIENTES_RAZSOCIAL;
  public CLIENTES_CONTRASENA;
  public CLIENTES_TELEFONO1;

  public CLIENTES_DIRECCION;
  public CLIENTES_POBLACION;
  public CLIENTES_PROVINCIA;
  public CLIENTES_CPOSTAL;
  public CLIENTES_NIF;

  public CODIGOTRABAJADOR;
  public NOMBRETRABAJADOR;
  // Trabajadores visibles en la lista para el estudio IA, solo lectura.
  public TRABAJADORES_IA: any[] = [];
  public imprimir = false;
  public btatras = false;

  public muestragif;
  public muestraerror;

  public usuarioregistroarray;
  private buscar2;

  public CONTROLACCESO = 0;

  public OBRA;

  public valorUsuario = "1";
  public todosLosVehiculos;
  public vehiculoElegido;
  public todosLasSalas;
  public salaElegido;
  public OpcionAReservar;
  public TIPO;

  public AnnoCal;
  public MesCal;

  public nombrefichero: string = "";

  public COLORGLOBAL = "";
  public COLORGLOBAL2 = "#000";
  public LOGOGLOBAL;
  public ESTADOGLOBAL;

  public VERMAPA;

  public agosto = "no";
  public primeraquincena = 1;
  public segundaquincena = 16;
  public diasAgosto = 0;
  public refrescar = "no";

  public diasOcupadosAgosto;
  public diasOcupadosNoAgosto;

  public ID;
  public GPS: string;
  public latitud;
  public longitud;

  public estadoOK;
  public IDtrabajador;
  public NOMBREtrabajador;
  public estadoVacaciones: string = "";

  public pausa: string = "";
  public estadoarray = {};
  public motivo: string = "";
  public obra: any = "";

  public incidencia: string = "";

  public ndias = 0;

  public diasRestantes;
  public diasVacaciones;

  public quepie = "sinpie";
  public pagina = "";

  public IDLINEA = ""; //falso

  public toDate = "";

  public selectedDay = "2019-02-16T17:41:50.425Z";


  public vacacionesTipos: any[] = [];
  public vacacionesTipoSeleccionado: any = null;
  public vacacionesResumenTipos: any[] = [];

  constructor(public events: Events, public http: Http) {
    this.logged = "";
    this.username = "";
    this.emailactivo = "";
    this.CLIENTES_CONTACTO = "";
    this.CLIENTES_RAZSOCIAL = "";
    this.CLIENTES_CONTRASENA = "";
    this.CLIENTES_TELEFONO1 = "";
    this.CLIENTES_DIRECCION = "";
    this.CLIENTES_POBLACION = "";
    this.CLIENTES_PROVINCIA = "";
    this.CLIENTES_CPOSTAL = "";
    this.CLIENTES_NIF = "";

    var usuarioregistroarray = {};

    this.pages = [{ title: "Inicio", visible: "S" }];
  }

  numeroAleatorio(min, max) {
    return Math.round(Math.random() * (max - min) + min);
  }

  getUserEmpresa() {

    let user = this.CLIENTES_RAZSOCIAL;
  
    if (!user || user == '') {
      user = this.emailoriginal;
    }
  
    return user;
  
  }

  liberarDiasAntiguos(ID, DIA) {

    return new Promise<any>(
      resolve => {
  
        this.http
          .get(
            "https://www.panel-control.com/picademo/recursos/sublogin.php/eliminavacacionesanteriores/" +
              ID +
              "/" +
              DIA
          )
          .map((res) => res.json())
          .subscribe(
            (data) => {
              resolve(data);
            },
            (err) => {
              console.log(err);
  
              resolve([
                {
                  RESULTADO: "ERROR",
                  MENSAJE: "Error borrando días antiguos"
                }
              ]);
            }
          );
  
      }
    );
  
  }

  obtenerVacacionesTipos() {

    return new Promise<any>(
      resolve => {
  
        let user = this.getUserEmpresa();
  
        this.http
          .get(
            "https://www.panel-control.com/picademo/recursos/sublogin.php/vacacionestipos/" +
              encodeURIComponent(user)
          )
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.vacacionesTipos = data;
  
              if (this.vacacionesTipos && this.vacacionesTipos.length > 0) {
  
                if (!this.vacacionesTipoSeleccionado) {
                  this.vacacionesTipoSeleccionado = this.vacacionesTipos[0];
                }
  
              }
  
              resolve(data);
            },
            (err) => {
              console.log(err);
              resolve([]);
            }
          );
  
      }
    );
  
  }


  confirmaVacacionesTipo(ID, DIA, agosto, tipo) {

    return new Promise<any>(
      resolve => {
  
        let tipo_id = 0;
        let codigo = 'VACACIONES';
  
        if (tipo) {
          tipo_id = tipo.id;
          codigo = tipo.codigo || tipo.nombre || 'VACACIONES';
        }
  
        this.http
          .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/confirmavacacionestipo/" +
              encodeURIComponent(ID) +
              "/" +
              encodeURIComponent(DIA) +
              "/" +
              encodeURIComponent(agosto) +
              "/" +
              encodeURIComponent(String(tipo_id)) +
              "/" +
              encodeURIComponent(codigo)
          )
          .map((res) => res.json())
          .subscribe(
            (data) => {
              resolve(data);
            },
            (err) => {
              console.log(err);
            }
          );
  
      }
    );
  
  }


  obtenerVacacionesConTipos(ID) {

    return new Promise<any>(
      resolve => {
  
        this.http
          .get(
            "https://www.panel-control.com/picademo/recursos/sublogin.php/obtenervacacionestipos/" +
              ID
          )
          .map((res) => res.json())
          .subscribe(
            (data) => {
              resolve(data);
            },
            (err) => {
              console.log(err);
              resolve([]);
            }
          );
  
      }
    );
  
  }

   parseSignedHHMM(s: string): number {
    if (!s) return 0;
    s = s.trim();
    let sign = 1;
    if (s[0] === '-') { sign = -1; s = s.slice(1); }
    else if (s[0] === '+') { s = s.slice(1); }
  
    const parts = s.split(':');
    const h = parseInt(parts[0], 10) || 0;
    const m = parseInt(parts[1], 10) || 0;
    return sign * (h * 60 + m);
  }
  
  // Formatea minutos con signo a "±HH:MM" (o "HH:MM" si es 0)
  fmtSigned(mins: number): string {
    const sign = mins < 0 ? '-' : (mins > 0 ? '' : '');
    const abs = Math.abs(mins);
    const h = Math.floor(abs / 60);
    const m = abs % 60;
    const hh = h < 10 ? '0' + h : '' + h;
    const mm = m < 10 ? '0' + m : '' + m;
    return (sign ? sign : '') + hh + ':' + mm;
  }
  
  // Sustituye tu SumaRestaFechaMin por esta versión simple y segura
  SumaRestaFechaMin(primera: string, segunda: string/*, operacion?: string*/): string {
    const total = this.parseSignedHHMM(primera) + this.parseSignedHHMM(segunda);
    return this.fmtSigned(total);
  }

  addRegistro(data) {
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve) => {
      //console.log("El array DESPUES" + data);
      this.http
        .put(
          "https://www.panel-control.com/picademo/recursos/usuario.php/mandarmaildealta",
          data,
          options
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
            //console.log("El array DESPUES2" + data);
          },
          (err) => {
            console.log(err);
            resolve([]);
          }
        );
    });
  }

  getficheros2(id) {
    return new Promise((resolve) => {
      this.http
        .get(
          "https://www.panel-control.com/picademo/files/directorio.php/directorio/" +
            id
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  getficheros(id) {
    return new Promise((resolve) => {
      this.http
        .get(
          "https://www.panel-control.com/picademo/files/directorio.php/dir/" +
            id
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }
  ficheroabierto(trabajador, fecha, visto, fichero) {
    return new Promise((resolve) => {
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/ficheroabierto/" +
            trabajador +
            "/" +
            fecha +
            "/" +
            visto +
            "/" +
            fichero
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  ConfiguraMenu(valor) {
    if (valor) {
      this.pages = [];
      //console.log("Primer valor" + valor.slice(0, 1));
      this.pages = [
        { title: "Inicio", visible: valor.slice(0, 1) },
        { title: "Trabajadores", visible: valor.slice(1, 2) },
        { title: "Empresas", visible: valor.slice(2, 3) },
        { title: "Lugares", visible: valor.slice(3, 4) },
        { title: "Turnos", visible: valor.slice(4, 5) },
        { title: "Fiestas", visible: valor.slice(5, 6) },
        { title: "Reservas", visible: valor.slice(6, 7) },
        { title: "Configuracion", visible: 'S' },
        { title: "User", visible: valor.slice(7) },
      ];

      this.events.publish("updateScreen");
    }
  }

  setRegistro(value) {
    this.usuarioregistroarray = value;
  }

  getRegistro() {
    return this.usuarioregistroarray;
  }

  setLogged(value) {
    this.logged = value;
  }

  getLogged() {
    return this.logged;
  }

  setusername(value) {
    this.username = value;
  }

  getusername() {
    return this.username;
  }

  setusermail(value) {
    this.usermail = value;
  }

  getusermail() {
    return this.usermail;
  }

  setBuscar2(value) {
    this.buscar2 = value;
  }

  getBuscar2() {
    return this.buscar2;
  }

  zfill(number, width) {
    var numberOutput = Math.abs(number); /* Valor absoluto del número */
    var length = number.toString().length; /* Largo del número */

    // console.log(number + " = Largo del numero:" + number.toString().length);

    var zero = "0"; /* String de cero */

    if (width <= length) {
      if (number < 0) {
        return "-" + numberOutput.toString();
      } else {
        return numberOutput.toString();
      }
    } else {
      if (number < 0) {
        return "-" + zero.repeat(width - length) + numberOutput.toString();
      } else {
        return zero.repeat(width - length) + numberOutput.toString();
      }
    }
  }

  obtienepuestos(filtro) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/puestos/"+filtro);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/puestos/" +
            filtro
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  obtieneempresas(filtro) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/empresas/"+filtro);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/empresas/" +
            filtro
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  obtieneobrasconfiltro(filtro) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/obras/"+filtro);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/obras/" +
            filtro
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  obtieneturnos(filtro) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/turnos/"+filtro);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/turnos/" +
            filtro
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  obtienegrupos() {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/grupos.php/grupos");
      this.http
        .get("https://www.panel-control.com/picademo/recursos/grupos.php/grupos")
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  confirmaReserva(
    vehiculo,
    trabajador,
    fechainicial,
    dias,
    obra,
    color,
    obser
  ) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/reservas.php/confirmareserva/"+vehiculo+"/"+trabajador+"/"+fechainicial+"/"+dias+"/"+obra+"/"+color+"/"+obser);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/reservas.php/confirmareserva/" +
            vehiculo +
            "/" +
            trabajador +
            "/" +
            fechainicial +
            "/" +
            dias +
            "/" +
            obra +
            "/" +
            color +
            "/" +
            obser
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  confirmaReservasala(sala, trabajador, fechainicial, dias, obra) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/reservas.php/confirmareservasala/"+sala+"/"+trabajador+"/"+fechainicial+"/"+dias+"/"+obra);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/reservas.php/confirmareservasala/" +
            sala +
            "/" +
            trabajador +
            "/" +
            fechainicial +
            "/" +
            dias +
            "/" +
            obra
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  obtieneobras(filtro) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/todaslasobras/"+filtro);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/todaslasobras/" +
            filtro
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  seltrabajador(empresa, obra, turno, idgrupo) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/grupos.php/seltrabajador/"+empresa+"/"+obra+"/"+turno+"/"+idgrupo);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/grupos.php/seltrabajador/" +
            empresa +
            "/" +
            obra +
            "/" +
            turno +
            "/" +
            idgrupo
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  selgrupos(codigo) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/grupos.php/selgrupos/"+codigo);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/grupos.php/selgrupos/" +
            codigo
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  grabargruposlin(codigo, trabajador) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/grupos.php/grabargruposlin/"+codigo+"/"+trabajador);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/grupos.php/grabargruposlin/" +
            codigo +
            "/" +
            trabajador
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }
  grabarobjetoslin(id_objeto, id_grupo) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/grupos.php/grabarobjetoslin/"+id_objeto+"/"+id_grupo);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/grupos.php/grabarobjetoslin/" +
            id_objeto +
            "/" +
            id_grupo
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }
  obtenerimagen(tabla, campo, id) {
    var datoss = {};
    datoss["TABLA"] = tabla;
    datoss["CAMPO"] = campo;
    datoss["ID"] = id;

    var valordevuelto;
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve) => {
      this.http
        .put(
          "https://www.panel-control.com/picademo/recursos/general.php/obtenerimagen",
          datoss,
          options
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }
  eliminaReserva(id) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/reservas.php/eliminareserva/"+id);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/reservas.php/eliminareserva/" +
            id
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }
  eliminaReservasala(id) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/reservas.php/eliminareservasala/"+id);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/reservas.php/eliminareservasala/" +
            id
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  editarreservavehiculos(dataito) {
    var datoss = {};
    var valordevuelto;
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve) => {
      this.http
        .put(
          "https://www.panel-control.com/picademo/recursos/reservas.php/editarreservavehiculos",
          dataito,
          options
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }
  editarturnosaviso(id, a1, t1, a2, t2, a3, t3, a4, t4) {
    return new Promise((resolve) => {
      //console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/editarturnosavisos/"+id+"/"+a1+"/"+t1+"/"+a2+"/"+t2+"/"+a3+"/"+t3+"/"+a4+"/"+t4);
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/editarturnosavisos/" +
            id +
            "/" +
            a1 +
            "/" +
            t1 +
            "/" +
            a2 +
            "/" +
            t2 +
            "/" +
            a3 +
            "/" +
            t3 +
            "/" +
            a4 +
            "/" +
            t4
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  confirmaVacaciones(ID, idObjeto, agosto) {
    return new Promise((resolve) => {
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/confirmavacaciones/" +
            ID +
            "/" +
            idObjeto +
            "/" +
            agosto
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  confirmaeldia(ID, idObjeto) {
    return new Promise((resolve) => {
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/confirmaeldia/" +
            ID +
            "/" +
            idObjeto
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  obtenerVacaciones(ID) {

    return new Promise((resolve) => {
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/obtenervacacionestipos/" +
            ID
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
            resolve([]);
          }
        );
    });
  }

  restodedias(ID, DIA) {
    console.log(
      "https://www.panel-control.com/picademo/recursos/sublogin.php/restodedias/" +
        ID +
        "/" +
        DIA
    );
    return new Promise((resolve) => {
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/restodedias/" +
            encodeURIComponent(ID) +
            "/" +
            encodeURIComponent(DIA)
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  liberarDia(ID, DIA) {
    return new Promise((resolve) => {
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/eliminavacaciones/" +
            ID +
            "/" +
            DIA
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  editadia(id, nombre) {
    return new Promise((resolve) => {
      console.log(
            "https://www.panel-control.com/picademo/recursos/sublogin.php/editadia/" +
              encodeURIComponent(id) +
              "/" +
              encodeURIComponent(nombre)
      );
      this.http
        .get(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/editadia/" +
            encodeURIComponent(id) +
            "/" +
            encodeURIComponent(nombre)
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/variables/variables.ts